import { Link } from 'react-router-dom';

export default function SEOContentSection() {
  return (
    <section className="bg-foreground-950 py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          <div className="lg:col-span-7">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">
              / GUIDA SEO
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-6">
              Itaobuy Spreadsheet: Il Database Italiano Completo
            </h2>
            <div className="space-y-4 text-background-50/75 text-sm md:text-base leading-relaxed">
              <p>
                <strong className="text-background-50 font-semibold">Itaobuy spreadsheet</strong> è diventato lo strumento essenziale per migliaia di italiani che
                cercano i migliori prodotti a prezzi competitivi. Il nostro database aggiornato raccoglie centinaia di
                categorie prodotto, dalle <strong className="text-background-50 font-semibold">sneakers</strong> più ricercate
                ai capi <strong className="text-background-50 font-semibold">streetwear</strong> più esclusivi, dagli accessori
                moda ai gadget tech più innovativi.
              </p>
              <p>
                Con <strong className="text-background-50 font-semibold">itaobuy spreadsheet italiano</strong> hai accesso a un catalogo
                completo con foto QC, recensioni verificate e link diretti ai migliori prodotti. La nostra
                <strong className="text-background-50 font-semibold"> guida completa</strong> ti accompagna passo dopo passo
                nella scelta, dall&apos;ordine alla spedizione internazionale.
              </p>
              <p>
                Che tu sia un principiante o un esperto di shopping online, il nostro
                <strong className="text-background-50 font-semibold"> itaobuy spreadsheet</strong> ti offre tutto ciò che serve:
                categorie aggiornate, controllo qualità dettagliato, suggerimenti su taglie e misure, e una community
                attiva di utenti italiani che condividono le loro esperienze e recensioni.
              </p>
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <div className="text-6xl md:text-7xl font-heading font-bold text-primary-500 mb-4">
                250K+
              </div>
              <p className="text-foreground-700 text-sm mb-6">
                Prodotti catalogati nel nostro database itaobuy spreadsheet, con aggiornamenti settimanali e nuove categorie
              </p>
              <div className="space-y-3 mb-8">
                {[
                  'Database prodotti aggiornato',
                  'Foto QC e controllo qualità',
                  'Guida taglie e misure',
                  'Recensioni utenti italiani',
                  'Link diretti alle categorie',
                ].map((item) => (
                  <div key={item} className="flex items-center gap-3">
                    <div className="w-5 h-5 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-check-line text-xs text-primary-600"></i>
                    </div>
                    <span className="text-sm text-foreground-600">{item}</span>
                  </div>
                ))}
              </div>
              <Link
                to="/guida-itaobuy-spreadsheet-italiano"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold whitespace-nowrap cursor-pointer bg-primary-500 text-background-50 hover:bg-primary-600 transition-all"
              >
                Leggi la guida completa
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}